export const SET_TO_INITIAL_VALUES = 'set_to_initial_values';
//export const SET_TO_INITIAL_VALUES_FORM = 'set_to_initial_values_form';
//export const SET_TO_INITIAL_VALUES_RUTAS = 'set_to_initial_values_rutas';
export const INVALID_TOKEN = 'invalid_token';
export const REFRESHING_TOKEN = 'refreshing_token';
export const REFRESH_EXPIRED = 'refresh_expired';
export const TOKEN_REFRESHED = 'token_refreshed';
export const CAMBIAR_STRING_APP = 'cambiar_string_app';
//export const CAMBIAR_STRING_AUTH = 'cambiar_string_auth';
//export const CAMBIAR_STRING_FORM = 'cambiar_string_form';
//export const CAMBIAR_STRING_RUTAS = 'cambiar_string_rutas';
//export const CAMBIAR_OBJECT_APP = 'cambiar_object_app';
//export const CAMBIAR_OBJECT_FORM = 'cambiar_object_form';
//export const CAMBIAR_OBJECT_RUTAS = 'cambiar_object_rutas';
export const ACTIVAR_SPINNER_APP = 'activar_spinner_app';
export const DESACTIVAR_SPINNER_APP = 'desactivar_spinner_app';
//export const ACTIVAR_SPINNER_ERROR = 'activar_spinner_error';
//export const ACTIVAR_SPINNER_FORM = 'activar_spinner_form';
//export const ACTIVAR_SPINNER_MODAL = 'activar_spinner_modal';
//export const DESACTIVAR_SPINNER_ERROR = 'desactivar_spinner_error';
//export const DESACTIVAR_SPINNER_FORM = 'desactivar_spinner_form';
//export const DESACTIVAR_SPINNER_MODAL = 'desactivar_spinner_modal';
export const MOSTRAR_ERROR_APP = 'mostrar_error_app';
export const SET_ARTICULO = 'set_articulo';
export const UNSET_ARTICULO = 'unset_articulo';
//export const MOSTRAR_ERROR = 'mostrar_error';
//export const MOSTRAR_ERROR_FORM = 'mostrar_error_form';
//export const MOSTRAR_ERROR_MODAL = 'mostrar_error_modal';
//export const OCULTAR_MODAL = 'ocultar_modal';
//export const LOGIN_DENEGADO_EN_API = 'login_denegado_en_api';
//export const LOGIN_SUCCESS_EN_API = 'login_success_en_api';
//export const SET_DATOS_USER_BASE = 'set_datos_user_base';
//export const ADD_USER_ASIGNADO = 'add_user_asignado';
//export const LIMPIAR_ERROR_MODAL_MENU = 'limpiar_error_modal_menu';
//export const LIMPIAR_ERROR = 'limpiar_error';
//export const VALIDAR_STRING_APP = 'validar_string_app';
